import Vue from 'vue';

import PortalVue from 'portal-vue'
Vue.use(PortalVue);

import VueHelpers from './_vue-helpers';
Vue.use(VueHelpers);

var VueTruncate = require('vue-truncate-filter');
Vue.use(VueTruncate);

import vClickOutside from 'v-click-outside';
Vue.use(vClickOutside);

import moment from "moment";
window.moment = moment;
window.moment.locale('fr');

import VueMomentLib from "vue-moment-lib";
Vue.use(VueMomentLib, {moment: moment});

import VModal from 'vue-js-modal';
Vue.use(VModal);

import { flareVue } from "@flareapp/flare-vue";
Vue.use(flareVue);